define('jquery', [],function () {
	return window.jQuery;
});

require([
	'require',
	'jquery',
	'modules/page',
	'widgets/route',
	'widgets/nav',
	'lib/jquery.pubsub',
], function (require, $, page) {

	// IE log polyfill
	console = window.console || { log: function () {} };

	var app = {

		init: function () {

			$($.proxy(this, 'setup'));
			return this;

		},

		setup: function () {

			this.page = page.setup();
			$('#nav').nav();

			$(document.body).addClass('page-ready');

			$.publish('appReady');

			return this;

		}

	};

	// Log ajax errors
	$(document).ajaxError(function(event, jqXHR, ajaxSettings, thrownError) {
		Raven && Raven.captureMessage(thrownError || jqXHR.statusText, {
			extra: {
				type: ajaxSettings.type,
				url: ajaxSettings.url,
				data: ajaxSettings.data,
				status: jqXHR.status,
				error: thrownError || jqXHR.statusText,
				response: jqXHR.responseText.substring(0, 100)
			}
		});
	});

	window.app = app;
	return app.init();

});
define("main", function(){});

